/// <amd-module name="Artifacts/Feed/components/ZeroFeeds" />
import * as Res from "Artifacts/Feed/Resources";
import { isUserAnonymousOrPublic } from "Artifacts/Root/helpers/UserHelpers";
import * as React from "react";
import { useEffect, useState } from "react";
import { useComponentContext } from "VSS/Platform/Layout";
import { getAssetLocation } from "VSS/Platform/Location";
import { Page } from "VSSUI/Page";
import { ZeroData, ZeroDataActionType } from "VSSUI/ZeroData";

export interface IZeroFeedsProps {
  showCreateFeed: () => void;
}

export const ZeroFeeds: React.FC<IZeroFeedsProps> = ({ showCreateFeed }) => {
  const { pageContext } = useComponentContext();
  const [isUserAnonymousOrPublicConst, setIsUserAnonymousOrPublicConst] = useState<
    boolean | undefined
  >();

  useEffect(() => {
    setIsUserAnonymousOrPublicConst(isUserAnonymousOrPublic(pageContext));
  }, [pageContext]);

  const imagePath = getAssetLocation(pageContext, "ms.azure-artifacts/feed/img/zerofeeds.svg");
  return isUserAnonymousOrPublicConst != null ? (
    <Page className="feed-hub">
      <ZeroData
        primaryText={Res.ZeroFeeds_NoFeeds_Message}
        secondaryText={isUserAnonymousOrPublicConst ? undefined : Res.ZeroFeeds_CreateFeed_Message}
        imagePath={imagePath}
        imageAltText={""}
        actionText={isUserAnonymousOrPublicConst ? undefined : Res.CreateFeedButton}
        actionType={isUserAnonymousOrPublicConst ? undefined : ZeroDataActionType.ctaButton}
        onActionClick={isUserAnonymousOrPublicConst ? undefined : showCreateFeed}
      />
    </Page>
  ) : null;
};
